import React from "react";
import "./../../UaeAttestation/UaeBlore/UaeBlore.css";
import UaeBloreHead from "../../UaeAttestation/UaeBlore/UaeBloreHead";
import MexicoBloreMain from "./MexicoBloreMain";
const MexicoBlore = () => {
  return (
    <div className="uaeBloreContainer">
      <UaeBloreHead head="Mexico Apostille in Bangalore" />
      <MexicoBloreMain />
    </div>
  );
};

export default MexicoBlore;
